import React from 'react';
import './Loader.css';

const Loader = ({
    size = 'medium',
    variant = 'spinner',
    color = 'primary',
    fullScreen = false,
    text = ''
}) => {
    const sizeClasses = {
        small: 'loader-small',
        medium: 'loader-medium',
        large: 'loader-large'
    };

    const colorClasses = {
        primary: 'loader-primary',
        secondary: 'loader-secondary',
        accent: 'loader-accent',
        white: 'loader-white'
    };

    const renderLoader = () => {
        switch (variant) {
            case 'spinner':
                return (
                    <div className={`loader-spinner ${sizeClasses[size]} ${colorClasses[color]}`}>
                        <div className="spinner-ring"></div>
                        <div className="spinner-ring"></div>
                        <div className="spinner-ring"></div>
                        <div className="spinner-ring"></div>
                    </div>
                );

            case 'dots':
                return (
                    <div className={`loader-dots ${sizeClasses[size]} ${colorClasses[color]}`}>
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                    </div>
                );

            case 'pulse':
                return (
                    <div className={`loader-pulse ${sizeClasses[size]} ${colorClasses[color]}`}>
                        <div className="pulse-circle"></div>
                    </div>
                );

            case 'bars':
                return (
                    <div className={`loader-bars ${sizeClasses[size]} ${colorClasses[color]}`}>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </div>
                );

            case 'orbit':
                return (
                    <div className={`loader-orbit ${sizeClasses[size]} ${colorClasses[color]}`}>
                        <div className="orbit-center"></div>
                        <div className="orbit-ring">
                            <div className="orbit-ball"></div>
                        </div>
                    </div>
                );

            default:
                return (
                    <div className={`loader-spinner ${sizeClasses[size]} ${colorClasses[color]}`}>
                        <div className="spinner-ring"></div>
                        <div className="spinner-ring"></div>
                        <div className="spinner-ring"></div>
                        <div className="spinner-ring"></div>
                    </div>
                );
        }
    };

    const loaderContent = (
        <div className="loader-content">
            {renderLoader()}
            {text && <p className="loader-text">{text}</p>}
        </div>
    );

    if (fullScreen) {
        return (
            <div className="loader-fullscreen">
                {loaderContent}
            </div>
        );
    }

    return loaderContent;
};

export default Loader;
